import { useState } from 'react';
import appConstants from '../../../../constants';
import { hasSuggestion, removeSuggestion } from '../helpers'

const defaults = Object.freeze({
  initialSelectedCountry: null,
  initialSelectedPartnerIntegratorLevelSuggestions: [],
  initialSelectedPartnerProviderLevelSuggestions: [],
  initialSelectedPartnerDeveloperLevelSuggestions: [],
  initialSelectedPartnerAdvisorLevelSuggestions: [],
  initialSelectedPartnerIntegratorSpecializationSuggestions: [],
  initialSelectedPartnerProviderCiscoPoweredServiceSuggestions: [],
  initialSelectedPartnerNameSuggestion: null
});

export default function useSuggestions(initialSelectedCountry = defaults.initialSelectedCountry,
                                       initialSelectedPartnerIntegratorLevelSuggestions = defaults.initialSelectedPartnerIntegratorLevelSuggestions,
                                       initialSelectedPartnerProviderLevelSuggestions = defaults.initialSelectedPartnerProviderLevelSuggestions,
                                       initialSelectedPartnerDeveloperLevelSuggestions = defaults.initialSelectedPartnerDeveloperLevelSuggestions,
                                       initialSelectedPartnerAdvisorLevelSuggestions = defaults.initialSelectedPartnerAdvisorLevelSuggestions,
                                       initialSelectedPartnerIntegratorSpecializationSuggestions = defaults.initialSelectedPartnerIntegratorSpecializationSuggestions,
                                       initialSelectedPartnerProviderCiscoPoweredServiceSuggestions = defaults.initialSelectedPartnerProviderCiscoPoweredServiceSuggestions,
                                       initialSelectedPartnerNameSuggestion = defaults.initialSelectedPartnerNameSuggestion) {

  const [selectedPartnerIntegratorLevelSuggestions, setSelectedPartnerIntegratorLevelSuggestions] = useState(initialSelectedPartnerIntegratorLevelSuggestions);
  const [selectedPartnerProviderLevelSuggestions, setSelectedPartnerProviderLevelSuggestions] = useState(initialSelectedPartnerProviderLevelSuggestions);
  const [selectedPartnerDeveloperLevelSuggestions, setSelectedPartnerDeveloperLevelSuggestions] = useState(initialSelectedPartnerDeveloperLevelSuggestions);
  const [selectedPartnerAdvisorLevelSuggestions, setSelectedPartnerAdvisorLevelSuggestions] = useState(initialSelectedPartnerAdvisorLevelSuggestions);
  const [selectedPartnerIntegratorSpecializationSuggestions, setSelectedPartnerIntegratorSpecializationSuggestions] = useState(initialSelectedPartnerIntegratorSpecializationSuggestions);
  const [selectedPartnerProviderCiscoPoweredServiceSuggestions, setSelectedPartnerProviderCiscoPoweredServiceSuggestions] = useState(initialSelectedPartnerProviderCiscoPoweredServiceSuggestions);
  const [selectedPartnerNameSuggestion, setSelectedPartnerNameSuggestion] = useState(initialSelectedPartnerNameSuggestion);
  const [selectedSearchTermsAsPartnerName, setSelectedSearchTermsAsPartnerName] = useState(null);

  function selectPartnerIntegratorLevelSuggestion(suggestion) {
     if(!hasSuggestion(selectedPartnerIntegratorLevelSuggestions, suggestion)) {
       setSelectedPartnerIntegratorLevelSuggestions(
         previousValue => [...selectedPartnerIntegratorLevelSuggestions, suggestion]
       );
     }
  }

  function unselectPartnerIntegratorLevelSuggestion(suggestion) {
    setSelectedPartnerIntegratorLevelSuggestions(
      previousValue => [...removeSuggestion(selectedPartnerIntegratorLevelSuggestions, suggestion)]
    );
  }


  function selectPartnerProviderLevelSuggestion(suggestion) {
    if(!hasSuggestion(selectedPartnerProviderLevelSuggestions, suggestion)) {
      setSelectedPartnerProviderLevelSuggestions(
        previousValue => [...selectedPartnerProviderLevelSuggestions, suggestion]
      );
    }
  }
  function unselectPartnerProviderLevelSuggestion(suggestion) {
    setSelectedPartnerProviderLevelSuggestions(
      previousValue => [...removeSuggestion(selectedPartnerProviderLevelSuggestions, suggestion)]
    );
  }

  function selectPartnerDeveloperLevelSuggestion(suggestion) {
    if(!hasSuggestion(selectedPartnerDeveloperLevelSuggestions, suggestion)) {
      setSelectedPartnerDeveloperLevelSuggestions(
        previousValue => [...selectedPartnerDeveloperLevelSuggestions, suggestion]
      );
    }
  }
  function unselectPartnerDeveloperLevelSuggestion(suggestion) {
    setSelectedPartnerDeveloperLevelSuggestions(
      previousValue => [...removeSuggestion(selectedPartnerDeveloperLevelSuggestions, suggestion)]
    );
  }

  function selectPartnerAdvisorLevelSuggestion(suggestion) {
    if(!hasSuggestion(selectedPartnerAdvisorLevelSuggestions, suggestion)) {
      setSelectedPartnerAdvisorLevelSuggestions(
        previousValue => [...selectedPartnerAdvisorLevelSuggestions, suggestion]
      );
    }
  }
  function unselectPartnerAdvisorLevelSuggestion(suggestion) {
    setSelectedPartnerAdvisorLevelSuggestions(
      previousValue => [...removeSuggestion(selectedPartnerAdvisorLevelSuggestions, suggestion)]
    );
  }


  function selectPartnerIntegratorSpecializationSuggestion(suggestion) {
    if(!hasSuggestion(selectedPartnerIntegratorSpecializationSuggestions, suggestion)) {
      setSelectedPartnerIntegratorSpecializationSuggestions(
        previousValue => [...selectedPartnerIntegratorSpecializationSuggestions, suggestion]
      );
    }
  }
  function unselectPartnerIntegratorSpecializationSuggestion(suggestion) {
    setSelectedPartnerIntegratorSpecializationSuggestions(
      previousValue => [...removeSuggestion(selectedPartnerIntegratorSpecializationSuggestions, suggestion)]
    );
  }

  function selectPartnerProviderCiscoPoweredServiceSuggestion(suggestion) {
    if(!hasSuggestion(selectedPartnerProviderCiscoPoweredServiceSuggestions, suggestion))
    setSelectedPartnerProviderCiscoPoweredServiceSuggestions(
      [...selectedPartnerProviderCiscoPoweredServiceSuggestions, suggestion]
    );
  }
  function unselectPartnerProviderCiscoPoweredServiceSuggestion(suggestion) {
    setSelectedPartnerProviderCiscoPoweredServiceSuggestions(
      [...removeSuggestion(selectedPartnerProviderCiscoPoweredServiceSuggestions, suggestion)]
    );
  }

  function selectPartnerNameSuggestion(suggestion) {
    setSelectedPartnerNameSuggestion( previousValue => { return {...suggestion} });
  }
  function unselectPartnerNameSuggestion(suggestion) {
    setSelectedPartnerNameSuggestion( previousValue => null );
  }

  function selectSearchedTermsAsPartnerName(suggestion) {
    setSelectedSearchTermsAsPartnerName( previousValue => { return {...suggestion}})
  }
  function unselectSearchedTermsAsPartnerName(suggestion) {
    setSelectedSearchTermsAsPartnerName(previousValue => null);
  }

  function resetSelectedSuggestions() {
    setSelectedPartnerIntegratorLevelSuggestions(previousValue => []);
    setSelectedPartnerProviderLevelSuggestions(previousValue => []);
    setSelectedPartnerDeveloperLevelSuggestions(previousValue => []);
    setSelectedPartnerAdvisorLevelSuggestions(previousValue => []);
    setSelectedPartnerIntegratorSpecializationSuggestions(previousValue => []);
    setSelectedPartnerProviderCiscoPoweredServiceSuggestions(previousValue => []);
    setSelectedPartnerNameSuggestion( previousValue => null );
    setSelectedSearchTermsAsPartnerName( previousValue => null );
  }

  function resetSelectedSuggestionFromSearchCriteria(searchCriteria) {
    if(!!searchCriteria && !!searchCriteria.length) {
      let partnerIntegratorLevelSuggestions = [];
      let partnerProviderLevelSuggestions = [];
      let partnerDeveloperLevelSuggestions = [];
      let partnerAdvisorLevelSuggestions = [];
      let partnerIntegratorSpecializationSuggestions = [];
      let partnerProviderCiscoPoweredServiceSuggestions = [];
      let partnerProviderPartnerNameSuggestion = null;
      let searchTermsAsPartnerNameSuggestion = null;

      searchCriteria.forEach(
        (searchCriterion) => {
          const typeSubTypeKey = `${searchCriterion[appConstants.KEY_TYPE]}-${searchCriterion[appConstants.KEY_SUBTYPE]}`;

          if (typeSubTypeKey === `${appConstants.VALUE_PARTNER_LEVEL}-${appConstants.VALUE_INTEGRATOR}`) {
            let updatedSearchCriterion = {...searchCriterion};
            updatedSearchCriterion[appConstants.KEY_IS_SELECTED] = true;
            partnerIntegratorLevelSuggestions.push(updatedSearchCriterion);
          }
          if (typeSubTypeKey === `${appConstants.VALUE_PARTNER_LEVEL}-${appConstants.VALUE_PROVIDER}`) {
            let updatedSearchCriterion = {...searchCriterion};
            updatedSearchCriterion[appConstants.KEY_IS_SELECTED] = true;
            partnerProviderLevelSuggestions.push(updatedSearchCriterion);
          }
          if (typeSubTypeKey === `${appConstants.VALUE_PARTNER_LEVEL}-${appConstants.VALUE_DEVELOPER}`) {
            let updatedSearchCriterion = {...searchCriterion};
            updatedSearchCriterion[appConstants.KEY_IS_SELECTED] = true;
            partnerDeveloperLevelSuggestions.push(updatedSearchCriterion);
          }
          if (typeSubTypeKey === `${appConstants.VALUE_PARTNER_LEVEL}-${appConstants.VALUE_ADVISOR}`) {
            let updatedSearchCriterion = {...searchCriterion};
            updatedSearchCriterion[appConstants.KEY_IS_SELECTED] = true;
            partnerAdvisorLevelSuggestions.push(updatedSearchCriterion);
          }

          if (typeSubTypeKey === `${appConstants.VALUE_PARTNER_SPECIALIZATION}-${appConstants.VALUE_INTEGRATOR}`) {
            let updatedSearchCriterion = {...searchCriterion};
            updatedSearchCriterion[appConstants.KEY_IS_SELECTED] = true;
            partnerIntegratorSpecializationSuggestions.push(updatedSearchCriterion);
          }
          if (typeSubTypeKey === `${appConstants.VALUE_CISCO_POWERED_SERVICE}-${appConstants.VALUE_PROVIDER}`) {
            let updatedSearchCriterion = {...searchCriterion};
            updatedSearchCriterion[appConstants.KEY_IS_SELECTED] = true;
            partnerProviderCiscoPoweredServiceSuggestions.push(updatedSearchCriterion);
          }
          if (typeSubTypeKey === `${appConstants.VALUE_PARTNER_NAME}-${appConstants.VALUE_PARTNER_NAME}`) {
            let updatedSearchCriterion = {...searchCriterion};
            updatedSearchCriterion[appConstants.KEY_IS_SELECTED] = true;
            partnerProviderPartnerNameSuggestion = updatedSearchCriterion;
          }
          if (typeSubTypeKey === `${appConstants.VALUE_PARTNER_NAME}-${appConstants.VALUE_PARTNER_NAME_KEYWORD}`) {
              let updatedSearchCriterion = {...searchCriterion};
              updatedSearchCriterion[appConstants.KEY_IS_SELECTED] = true;
              searchTermsAsPartnerNameSuggestion = updatedSearchCriterion;
          }
        }
      );
      setSelectedPartnerIntegratorLevelSuggestions(previousValue => partnerIntegratorLevelSuggestions);
      setSelectedPartnerProviderLevelSuggestions(previousValue => partnerProviderLevelSuggestions);
      setSelectedPartnerDeveloperLevelSuggestions(previousValue => partnerDeveloperLevelSuggestions);
      setSelectedPartnerAdvisorLevelSuggestions(previousValue => partnerAdvisorLevelSuggestions);
      setSelectedPartnerIntegratorSpecializationSuggestions(previousValue => partnerIntegratorSpecializationSuggestions);
      setSelectedPartnerProviderCiscoPoweredServiceSuggestions(previousValue => partnerProviderCiscoPoweredServiceSuggestions);
      setSelectedPartnerNameSuggestion( previousValue => partnerProviderPartnerNameSuggestion );
      setSelectedSearchTermsAsPartnerName( previousValue => searchTermsAsPartnerNameSuggestion );
    }
  }

  return {
    selectedPartnerIntegratorLevelSuggestions,
    selectedPartnerProviderLevelSuggestions,
    selectedPartnerDeveloperLevelSuggestions,
    selectedPartnerAdvisorLevelSuggestions,
    selectedPartnerIntegratorSpecializationSuggestions,
    selectedPartnerProviderCiscoPoweredServiceSuggestions,
    selectedPartnerNameSuggestion,
    selectedSearchTermsAsPartnerName,

    selectPartnerIntegratorLevelSuggestion,
    selectPartnerProviderLevelSuggestion,
    selectPartnerDeveloperLevelSuggestion,
    selectPartnerAdvisorLevelSuggestion,
    selectPartnerIntegratorSpecializationSuggestion,
    selectPartnerProviderCiscoPoweredServiceSuggestion,
    selectPartnerNameSuggestion,
    selectSearchedTermsAsPartnerName,

    unselectPartnerIntegratorLevelSuggestion,
    unselectPartnerProviderLevelSuggestion,
    unselectPartnerDeveloperLevelSuggestion,
    unselectPartnerAdvisorLevelSuggestion,
    unselectPartnerIntegratorSpecializationSuggestion,
    unselectPartnerProviderCiscoPoweredServiceSuggestion,
    unselectPartnerNameSuggestion,
    unselectSearchedTermsAsPartnerName,

    resetSelectedSuggestions,

    resetSelectedSuggestionFromSearchCriteria
  };
}
